import { render, staticRenderFns } from "./TahsilatlarView.vue?vue&type=template&id=6ded055a"
import script from "./TahsilatlarView.vue?vue&type=script&lang=ts"
export * from "./TahsilatlarView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports